import { MDBBtn, MDBRow, MDBCol, MDBIcon, MDBModal } from "mdbreact";
import React from "react";
import classes from "./TenantDescriptionModal.module.scss";

type TenantDescriptionModalProps = {
  /** モーダルが開かれているか否か */
  isOpenModal: boolean;
  /** ボタンを隠すか */
  isActionButtonHidden?: boolean;
  /** モーダルを閉じる */
  onCloseButtonClick: () => void;
  /** 選択ボタンが押されたらテナントをスタンプカードにセットする */
  onStampSelect: () => void;
  /** モーダルが開かれたテナントの情報 */
  tenantDescription?: TenantDescription;
};

/**
 * テナント詳細情報
 */
type TenantDescription = {
  /** テナント画像 */
  image: string;
  /** テナント名 */
  name: string;
  /** テナント説明 */
  description: string;
  /** おすすめかどうか */
  isRecommended: boolean;
  /** ジャンル */
  genre?: string;
  /** フロア */
  floor?: string;
  /** 営業時間 */
  businessHours?: string;
  /** 電話番号 */
  tel?: string;
  /** 予算 */
  budget?: string;
};

/**
 * タップ（クリックされた）テナントの情報を表示するコンポーネント
 */
const TenantDescriptionModal: React.FC<TenantDescriptionModalProps> = (
  props
) => {
  return (
    <MDBModal
      className={classes.modal}
      isOpen={props.isOpenModal}
      toggle={() => {}}
      position="right"
    >
      <div
        className={`pl-2 py-2 d-flex align-items-center ${classes.header}`}
        onClick={props.onCloseButtonClick}
      >
        <MDBIcon className={`mx-2 ${classes.backArrowLeft}`} icon="times" />
        <span className="ml-2">閉じる</span>
      </div>
      {props.tenantDescription && (
        <React.Fragment>
          <div className="m-2 text-center">
            <img
              className={`img-fluid d-inline ${classes.tenantImage}`}
              src={props.tenantDescription.image}
              alt=""
            />
          </div>

          <div className={`py-3 px-3 ${classes.modalBody}`}>
            <div className="d-table w-100">
              <div className="d-table-cell text-left">
                {props.tenantDescription.genre ? (
                  <span className={`mr-2 ${classes.genruText}`}>
                    {props.tenantDescription.genre}
                  </span>
                ) : null}
                {props.tenantDescription.floor ? (
                  <span className={classes.floorText}>
                    {props.tenantDescription.floor}
                  </span>
                ) : null}
              </div>
            </div>

            <div className={`mt-3 ${classes.tenantName}`}>
              {props.tenantDescription.name}
            </div>

            <div className={`my-3 ${classes.description}`}>
              {props.tenantDescription.description}
            </div>

            {!props.isActionButtonHidden ? (
              <MDBRow className={`my-2 my-sm-3 ${classes.buttons}`}>
                <MDBCol size="12" className="d-flex justify-content-center">
                  <MDBBtn
                    className={`mx-3 text-center ${classes.selectButton}`}
                    color="yellow"
                    onClick={() => {
                      props.onStampSelect();
                    }}
                  >
                    このショップを選択する
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            ) : null}
          </div>
        </React.Fragment>
      )}
    </MDBModal>
  );
};

export default TenantDescriptionModal;
